import {
  IAcademicsLibraryItem,
  LibraryAssetType,
  BorrowingStatus,
  BorrowerType,
  DamageSeverity,
  DamageStatus,
} from '../../apis/academics/academicsLibrary.interfaces';
import { MaterialCondition } from '../../apis/academics/academicsMaterials.interfaces';

export const mockAcademicsLibrary: IAcademicsLibraryItem[] = [
  {
    id: 'lib-001',
    assetCode: 'LIB-BK-001',
    title: 'Introduction to Computer Science',
    assetType: LibraryAssetType.BOOK,
    description:
      'Comprehensive textbook covering fundamental concepts of computer science including algorithms, data structures, and programming paradigms.',
    condition: MaterialCondition.GOOD,
    currentStatus: BorrowingStatus.BORROWED,
    location: 'Shelf A-12, Row 3',
    purchaseDate: '2023-01-15',
    purchaseCost: 45.99,
    supplier: 'Academic Books Ltd.',
    tags: ['computer-science', 'textbook', 'programming', 'algorithms'],
    isbn: '978-0-123456-78-9',
    author: 'Dr. Jane Smith',
    publisher: 'Tech Education Press',
    edition: '3rd Edition',
    publicationYear: 2022,
    subject: 'Computer Science',
    gradeLevel: 'Grade 9-12',
    language: 'English',
    isDigital: false,
    createdAt: '2023-01-20T10:00:00Z',
    createdBy: 'staff-001',
    updatedAt: '2024-01-15T14:30:00Z',
    updatedBy: 'staff-002',
    currentBorrowing: {
      recordId: 'borrow-001',
      assetId: 'lib-001',
      borrowerId: 'student-123',
      borrowerType: BorrowerType.STUDENT,
      borrowerName: 'John Doe',
      borrowerEmail: 'john.doe@school.edu',
      borrowerPhone: '+1-555-0123',
      borrowedDate: '2024-01-10T09:00:00Z',
      dueDate: '2024-01-24T17:00:00Z',
      status: BorrowingStatus.BORROWED,
      renewalCount: 0,
      fineAmount: 0,
      finePaid: true,
      notes: 'Student requested extension for project work',
      issuedBy: 'staff-002',
      createdAt: '2024-01-10T09:00:00Z',
      updatedAt: '2024-01-10T09:00:00Z',
    },
    borrowingHistory: [
      {
        recordId: 'borrow-hist-001',
        assetId: 'lib-001',
        borrowerId: 'student-456',
        borrowerType: BorrowerType.STUDENT,
        borrowerName: 'Alice Johnson',
        borrowerEmail: 'alice.johnson@school.edu',
        borrowedDate: '2023-11-01T10:00:00Z',
        dueDate: '2023-11-15T17:00:00Z',
        returnDate: '2023-11-14T16:30:00Z',
        status: BorrowingStatus.AVAILABLE,
        renewalCount: 1,
        lastRenewalDate: '2023-11-10T10:00:00Z',
        fineAmount: 0,
        finePaid: true,
        issuedBy: 'staff-001',
        returnedTo: 'staff-001',
        createdAt: '2023-11-01T10:00:00Z',
        updatedAt: '2023-11-14T16:30:00Z',
      },
    ],
    damageHistory: [],
    totalBorrows: 12,
    totalDamages: 0,
    lastBorrowedDate: '2024-01-10T09:00:00Z',
    lastReturnedDate: '2023-11-14T16:30:00Z',
    isAvailable: false,
    canBeBorrowed: true,
    maxBorrowDays: 14,
    renewalAllowed: true,
    maxRenewals: 2,
    borrowerRestrictions: {
      allowedBorrowerTypes: [BorrowerType.STUDENT, BorrowerType.STAFF],
      minimumGradeLevel: 'Grade 9',
      requiresApproval: false,
    },
    replacementCost: 45.99,
    notes:
      'Popular textbook, frequently borrowed. Consider purchasing additional copies.',
  },
  {
    id: 'lib-002',
    assetCode: 'LIB-EQ-045',
    title: 'Digital Microscope Pro 2000X',
    assetType: LibraryAssetType.LAB_EQUIPMENT,
    description:
      'High-resolution digital microscope with 2000X magnification, USB connectivity, and built-in LED illumination. Suitable for biology and chemistry labs.',
    condition: MaterialCondition.FAIR,
    currentStatus: BorrowingStatus.AVAILABLE,
    location: 'Lab Equipment Storage, Cabinet B-5',
    purchaseDate: '2022-06-10',
    purchaseCost: 899.99,
    supplier: 'Scientific Instruments Co.',
    tags: ['microscope', 'lab-equipment', 'biology', 'chemistry', 'digital'],
    subject: 'Science',
    gradeLevel: 'Grade 10-12',
    language: 'English',
    equipmentType: 'Digital Microscope',
    modelNumber: 'DM-PRO-2000X',
    manufacturer: 'SciTech Instruments',
    serialNumber: 'ST-2022-045-789',
    createdAt: '2022-06-15T08:00:00Z',
    createdBy: 'staff-003',
    updatedAt: '2024-01-12T11:20:00Z',
    updatedBy: 'staff-002',
    borrowingHistory: [
      {
        recordId: 'borrow-hist-002',
        assetId: 'lib-002',
        borrowerId: 'staff-101',
        borrowerType: BorrowerType.STAFF,
        borrowerName: 'Dr. Robert Chen',
        borrowerEmail: 'r.chen@school.edu',
        borrowerPhone: '+1-555-0456',
        borrowedDate: '2023-09-05T08:00:00Z',
        dueDate: '2023-09-19T17:00:00Z',
        returnDate: '2023-09-18T15:00:00Z',
        status: BorrowingStatus.AVAILABLE,
        renewalCount: 0,
        fineAmount: 0,
        finePaid: true,
        notes: 'Used for advanced biology class demonstrations',
        issuedBy: 'staff-002',
        returnedTo: 'staff-002',
        createdAt: '2023-09-05T08:00:00Z',
        updatedAt: '2023-09-18T15:00:00Z',
      },
    ],
    damageHistory: [
      {
        recordId: 'damage-001',
        assetId: 'lib-002',
        reportedDate: '2023-10-20T10:00:00Z',
        reportedBy: 'staff-002',
        reportedByName: 'Library Staff',
        damageSeverity: DamageSeverity.MINOR,
        damageStatus: DamageStatus.REPAIRED,
        damageDescription:
          'Minor scratch on the LED lens cover. Does not affect functionality.',
        damageLocation: 'LED illumination lens cover',
        estimatedRepairCost: 25.0,
        actualRepairCost: 20.0,
        repairStartDate: '2023-10-22T09:00:00Z',
        repairCompletionDate: '2023-10-25T16:00:00Z',
        repairedBy: 'In-house maintenance team',
        notes:
          'Lens cover replaced successfully. Equipment tested and fully functional.',
        createdAt: '2023-10-20T10:00:00Z',
        updatedAt: '2023-10-25T16:00:00Z',
      },
    ],
    totalBorrows: 8,
    totalDamages: 1,
    lastBorrowedDate: '2023-09-05T08:00:00Z',
    lastReturnedDate: '2023-09-18T15:00:00Z',
    isAvailable: true,
    canBeBorrowed: true,
    maxBorrowDays: 14,
    renewalAllowed: true,
    maxRenewals: 1,
    borrowerRestrictions: {
      allowedBorrowerTypes: [BorrowerType.STAFF],
      requiresApproval: true,
    },
    replacementCost: 899.99,
    notes:
      'Requires staff approval for borrowing. Handle with care - expensive equipment.',
  },
  {
    id: 'lib-003',
    assetCode: 'LIB-DR-128',
    title: 'Interactive Mathematics Learning Platform',
    assetType: LibraryAssetType.DIGITAL_RESOURCE,
    description:
      'Comprehensive digital learning platform covering algebra, geometry, calculus, and statistics. Includes interactive exercises, video tutorials, and practice tests.',
    condition: MaterialCondition.NEW,
    currentStatus: BorrowingStatus.AVAILABLE,
    location: 'Digital Resources Portal',
    purchaseDate: '2024-01-01',
    purchaseCost: 299.99,
    supplier: 'EduTech Solutions',
    tags: [
      'mathematics',
      'digital',
      'interactive',
      'learning-platform',
      'online',
    ],
    subject: 'Mathematics',
    gradeLevel: 'Grade 6-12',
    language: 'English',
    isDigital: true,
    digitalFormat: 'other',
    digitalUrl: 'https://library.school.edu/digital/math-platform-2024',
    createdAt: '2024-01-05T09:00:00Z',
    createdBy: 'staff-001',
    updatedAt: '2024-01-05T09:00:00Z',
    updatedBy: 'staff-001',
    borrowingHistory: [],
    damageHistory: [],
    totalBorrows: 0,
    totalDamages: 0,
    isAvailable: true,
    canBeBorrowed: true,
    maxBorrowDays: 30,
    renewalAllowed: true,
    maxRenewals: 3,
    borrowerRestrictions: {
      allowedBorrowerTypes: [
        BorrowerType.STUDENT,
        BorrowerType.STAFF,
        BorrowerType.PARENT,
      ],
      requiresApproval: false,
    },
    replacementCost: 299.99,
    notes:
      'New digital resource. Access provided via library portal. License valid until Dec 2024.',
  },
];
